import api from 'apis/config/api-service';

interface CategoryParams {
  [key: string]: any;
}

export default {
  // Supplier categories for the supplier forms; only the isActive filter is used by callers.
  getCategories: (params?: CategoryParams) =>
    api.get('api/v1/categories/all', {
      params: { page: 1, limit: 100, ...(params?.filters?.isActive ? { isActive: params.filters.isActive.eq } : {}) },
    }),
};
